module.exports = __webpack_public_path__ + "assets/img/a1e6571d85ce68a512676757f3a1e823.png";